import { CreditUsageType, Maybe } from '@aibees/shared/definition';
import { UseBoolean, useCreditUsageItem } from '@aibees/shared/hooks';
import { useMemo } from 'react';

export function useCalculateContactCredits(
  leads: Maybe<number>,
  validWorkEmail: UseBoolean,
  mobilePhoneNumber: UseBoolean,
  fullProfileEnrichment: UseBoolean
) {
  const emailFoundCreditUsage = useCreditUsageItem(
    CreditUsageType.CONTACT_EMAIL_FINDING
  );
  const enrichmentFetchCreditUsage = useCreditUsageItem(
    CreditUsageType.CONTACT_PROFILE_REVEAL
  );
  const mobilePhoneNumberCreditUsage = useCreditUsageItem(
    CreditUsageType.CONTACT_PHONE_FINDING
  );
  return useMemo(() => {
    let multiplier = 0.5;
    if (validWorkEmail.value) multiplier += emailFoundCreditUsage.credit ?? 0;
    if (mobilePhoneNumber.value)
      multiplier += mobilePhoneNumberCreditUsage.credit ?? 0;
    if (fullProfileEnrichment.value)
      multiplier += enrichmentFetchCreditUsage.credit ?? 0;
    return (leads ?? 0) * multiplier;
  }, [
    leads,
    validWorkEmail.value,
    mobilePhoneNumber.value,
    fullProfileEnrichment.value,
  ]);
}
